import React from 'react';
import { useSelector } from 'store';

interface IProps {
  closeModal: () => void;
}

const ModalTerms: React.FC<IProps> = ({ closeModal }: IProps) => {
  const terms = useSelector(state => state.site.terms);

  return (
    <div className="dimd-layer">
      <div className="inner big-type">
        <section className="privacy-w">
          <div dangerouslySetInnerHTML={{ __html: terms.text }} />
          <button type="button" className="btn-close" onClick={closeModal}>
            <span>팝업 닫기</span>
          </button>
        </section>
      </div>
    </div>
  );
};

export default ModalTerms;
